import React from 'react';
import {
  Box,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from '@mui/material';

interface EmployeeToolbarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  filterStatus: 'all' | 'active' | 'retired';
  onFilterStatusChange: (value: 'all' | 'active' | 'retired') => void;
  totalCount: number;
  totalMP: number;
  hourlyCount: number;
  salaryCount: number;
  filteredCount: number;
  onAddClick: () => void;
}

export const EmployeeToolbar: React.FC<EmployeeToolbarProps> = ({
  searchTerm,
  onSearchChange,
  filterStatus,
  onFilterStatusChange,
  totalCount,
  totalMP,
  hourlyCount,
  salaryCount,
  filteredCount,
  onAddClick,
}) => (
  <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, mb: 2, p: 2, background: 'var(--bg-elev-2)', borderRadius: 1, border: '1px solid var(--border-default)' }}>
    <TextField
      size="small"
      placeholder="직원명으로 검색..."
      value={searchTerm}
      onChange={(e) => onSearchChange(e.target.value)}
      sx={{ minWidth: 200 }}
    />
    <FormControl size="small" sx={{ minWidth: 120 }}>
      <InputLabel>상태 필터</InputLabel>
      <Select value={filterStatus} label="상태 필터" onChange={(e) => onFilterStatusChange(e.target.value as 'all' | 'active' | 'retired')}>
        <MenuItem value="all">전체</MenuItem>
        <MenuItem value="active">재직중</MenuItem>
        <MenuItem value="retired">퇴직</MenuItem>
      </Select>
    </FormControl>
    <Typography variant="body2" color="text.secondary">
      총 {filteredCount}명
    </Typography>
    <Box sx={{ display: 'flex', gap: 2, ml: 'auto' }}>
      <Typography variant="body2" color="text.secondary">
        총 직원: {totalCount}명
      </Typography>
      <Typography variant="body2" color="text.secondary">
        ManPower: {totalMP}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        시급제 {hourlyCount}명 / 월급제 {salaryCount}명
      </Typography>
    </Box>
    <Button variant="contained" onClick={onAddClick} sx={{ background: 'var(--primary)', '&:hover': { background: 'var(--primary-hover)' } }}>
      직원 추가
    </Button>
  </Box>
);
